import React, {useState} from 'react';
import {Button, Popover} from "antd";
import api from "../../api/apiInterceptor";
import {store} from "../../redux-store/store";
import {displayNotification} from "../../redux-store/notification";
import {getDynamicTableAndLocations} from "../../redux-store/dynamicTable";
import {useSelector} from "react-redux";
import {installationSelectData} from "../../redux-store/selectors";
import trashIcon from "../../images/bin.svg";

function DeleteRowButton({cell, tableId}) {

    const {selected} = useSelector(installationSelectData)

    const [show, setShow] = useState(false)

    const content = () => {

        const handleDelete = async () => {

            let rowId = cell[Object.keys(cell)[0]].rowId

            try {
                await api.delete(`/api/installations/${selected.value}/tableviews/${tableId}/rows/${rowId}`)
                store.dispatch(displayNotification({
                    notificationStatus: "success",
                    message: "Uspješno obrisan red",
                    title: "Tabele"
                }))
            } catch (e) {
                store.dispatch(displayNotification({
                    notificationStatus: "error",
                    message: "Greška prilikom brisanja reda",
                    title: "Tabele"
                }))
            }

            store.dispatch(getDynamicTableAndLocations({
                installationId: selected.value,
                tableId: tableId,
            }))

            setShow(false)

        }

        return (
            <>
                <Button onClick={handleDelete} className={"btn-save-antd"}>Potvrdi</Button>
                <Button onClick={()=>{setShow(false)}} className={"btn-cancel-antd"}>Otkazi</Button>
            </>
        )
    }

    return (
        <Popover visible={show} content={content} title="Brisanje"
                 trigger="click" className={"cursor-button atn-popover-flux"}>
            <img onClick={()=>{setShow(true)}} src={trashIcon} alt={"Trash Icon"}
            />
        </Popover>
    );
}

export default DeleteRowButton;